<template>
  <div class="wrapper">
    <div>
      <HTMLHeader></HTMLHeader>

      <section class="errorpage">
        <div class="container">
          <div class="row">
            <div class="col-xs-12">
              <div v-if="status === 404">
                <h1>Hiba 404</h1>
                <h3>A keresett fájl nem létezik.</h3>
              </div>

              <div v-if="status === 401">
                <h1>Hiba 401</h1>
                <h3>A fájl megtekintéséhez be kell jelentkezni.</h3>
              </div>

              <div v-if="status === 403">
                <h1>Hiba 403</h1>
                <h3>A fájl megtekintéséhez nincs jogosultsága.</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <HTMLFooter></HTMLFooter>
      <ProfileMenu></ProfileMenu>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import HTMLHeader from './tpl_header.vue';
import HTMLFooter from './tpl_footer.vue';
import ProfileMenu from './tpl_profile_menu.vue';

export default {
  components: {
    HTMLHeader,
    HTMLFooter,
    ProfileMenu
  },
  data: function () {
    return {
      status: 200
    }
  },
  computed: {
    imageSrc: function() {
      const fileName = this.$route.params.filename;
      const filePath = './' + api_url + 'uploads/' + fileName;
      return filePath;
    }
  },
  mounted: function() {
    var _this = this;

    console.log('mounted');

    Vue.nextTick(function() {
      _this.resizeImage();
      setHeaderDarkLine();
      $(window).resize(function() {
        _this.resizeImage();
        setHeaderDarkLine();
      });
    });

    $.ajax(_this.imageSrc, {
      method: 'GET',
      success: function(response) {
        if (response.status === undefined) {
          location.href = _this.imageSrc;
        } else {
          _this.status = response.status;
        }
      },
      error: function(err) {
        console.error(err);
      }
    });
  },
  methods: {
    resizeImage: function() {
      $('.errorpage').css({
        'min-height': $(window).innerHeight() - $('footer').outerHeight() - $('header').outerHeight()
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// uploads.vue?2dff46b8